import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'
import { TeamCard } from '../TeamCard'

import { useTeam } from '../../api/getTeam'

export const Teams = () => {
  const team = useTeam()
  if (team.isLoading)
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
      </div>
    )
  if (!team.data) return null
  return (
    <section className={`${pageXPadding} ${pageYPadding}`}>
      <div className={`${pageMaxWidth} mx-auto flex flex-col gap-y-[45px] `}>
        <div className="flex justify-center">
          <SectionTitle variant="tertiary" title="Meet Our Team" />
        </div>
        <div className="flex flex-col items-center  gap-y-[32px] md:flex-row md:flex-wrap md:gap-x-[75px] ">
          {team.data.map(({ image: { id, url }, name, role }) => (
            <TeamCard key={id} name={name} position={role} imageUrl={url} />
          ))}
        </div>
      </div>
    </section>
  )
}
